// extracted by mini-css-extract-plugin
export default {"paginationLoadMore":"PaginationLoadMore_paginationLoadMore__u3NOB","paginationLoadMore__button":"PaginationLoadMore_paginationLoadMore__button__kkK3B"};